﻿import * as eventTypes from '../../../map/utils/eventTypes';
export default class GeolocationControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.active = false;
    }

    init() {
        this.menuContainer.append(this._getActionButtonTemplate());
        document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());

        this._getCurrentLocationVisibilityChangedHandler();
        this._createGeolocationErrorHandler();
    }

    _actionButtonClickHandler() {
        return () => {
            if (this.active) {
                this._hideGeolocation();
            } else {
                this._showGeolocation();
            }
        };
    }

    _hideGeolocation() {
        $('#' + this.elementId).removeClass('selected');
        $('#' + this.elementId).removeClass("active");
        $('#' + this.elementId).prop('title', this.resourcesHandler.get("Activate Geolocation"));
        this.active = false;
        this.mapControl.geolocationHandler.clearWatch();
        $event.unregister(eventTypes.GEOLOCATION_ERROR, this.geolocationErrorHandler, this, this.classId);
        $event.unregister(eventTypes.CURRENT_LOCATION_VISIBLITY_CHANGED, this.currentLocationVisibilityChangedHandler, this, this.classId);
    }

    _showGeolocation() {
        $('#' + this.elementId).addClass('selected');
        $('#' + this.elementId).addClass("active");
        $('#' + this.elementId).prop('title', this.resourcesHandler.get("Deactivate Geolocation"));
        this.active = true;
        this.mapControl.geolocationHandler.watchPosition();

        $event.register(eventTypes.GEOLOCATION_ERROR, this.geolocationErrorHandler, this, this.classId);
        $event.register(eventTypes.CURRENT_LOCATION_VISIBLITY_CHANGED, this.currentLocationVisibilityChangedHandler, this, this.classId);
    }

    _getCurrentLocationVisibilityChangedHandler() {
        this.currentLocationVisibilityChangedHandler = (eventName, data, sender) => {
            if (data.position == "inside") {
                $('#' + this.elementId).addClass("active");
                $('#' + this.elementId).prop('title', this.resourcesHandler.get("Deactivate Geolocation"));
            }
            else {
                $('#' + this.elementId).removeClass("active");
                $('#' + this.elementId).prop('title', this.resourcesHandler.get("Activate Geolocation"));
            }
        };
    }

    _createGeolocationErrorHandler(eventName, data, sender) {
        this.geolocationErrorHandler = (eventName, eventArgs, sender) => {
            $event.unregister(eventTypes.GEOLOCATION_ERROR, this.geolocationErrorHandler, this, this.classId);
            $event.unregister(eventTypes.CURRENT_LOCATION_VISIBLITY_CHANGED, this.currentLocationVisibilityChangedHandler, this, this.classId);

            $('#' + this.elementId).removeClass("active");
            $('#' + this.elementId).prop('title', this.resourcesHandler.get("Activate Geolocation"));

            var title = this.resourcesHandler.get('Error');
            var msgKey = "ErrorGeolocation_Code" + data.code.toString();
            var msg = this.resourcesHandler.get(msgKey);

            toastr.error(msg, title);
        }
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}